




















import {Component, Vue, Mixins} from "vue-property-decorator";
import { ClientProject, ClientProjectService, Invoice } from "../../../services/accounting.service";
import ClientProjectsList from "./List.vue"
import ClientProjectsForm from "./Form.vue"
import ClientProjectTasks from "./tasks/Index.vue"
import { ApiResponse, HashMap } from "../../../services/base.service";

@Component({
    components: {
        ClientProjectsList,
        ClientProjectsForm,
        ClientProjectTasks,
    }
})
export default class ClientProjectsIndex extends Vue {
    
    formOpen: boolean = false;
    taskFormOpen: boolean = false;
    editing: ClientProject | null = null;
    projects: ClientProject[] = [];

    api!: ClientProjectService;

    async created() {
        this.api = new ClientProjectService();
        await this.refresh();
    }

    async refresh() {
        const res = await this.api.get();
        if (res.success) {
            this.projects = res.result;
            if (this.editing) {
                for (const project of this.projects) {
                    if (project.id === this.editing.id) {
                        this.editing = project;
                    }
                }
            }
            
        }
    }

    cancelEdit() {
        this.formOpen = false;
        this.taskFormOpen = false;
        this.editing = null;
    }

    async create() {
        this.formOpen = true;
        this.editing = null;
    }

    async edit(project: ClientProject) {
        this.formOpen = true;
        this.editing = project;
    }

    editTasks(project: ClientProject) {
        this.taskFormOpen = true;
        this.editing = project;
    }

    async remove(project: ClientProject) {
        await this.api.delete(project.id);
        await this.refresh();
    }

    async success() {
        this.formOpen = false;
        this.editing = null;
        await this.refresh();
    }

    async invoice(project: ClientProject) {
        const res = await this.api.invoice(project);
        console.log(res);
        if (res.success === false) {
            alert("Nothing to be invoiced for this project");
        }
    }

    async quote(project: ClientProject) {
        const res = await this.api.quote(project);
        if (res.success === false) {
            alert("Nothing to be quoted for this project");
        }
    }
}
